webpackJsonp([117145912097080],{

/***/ 1337:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"AccountCreditHistoryOrderBy","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"amount","type":{"kind":"ENUM","name":"OrderByDirection","ofType":null}},{"defaultValue":null,"description":null,"name":"datetime","type":{"kind":"ENUM","name":"OrderByDirection","ofType":null}},{"defaultValue":null,"description":null,"name":"insertedAt","type":{"kind":"ENUM","name":"OrderByDirection","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-account-credit-history-order-by-7e9c2ead071c2c2be7ec.js